export default {
    'en-US': {
        'tecton.element.calendar.close': 'Close',
        'tecton.element.calendar.previousMonth': 'Previous month',
        'tecton.element.calendar.nextMonth': 'Next month',
        'tecton.element.calendar.previousYear': 'Previous year',
        'tecton.element.calendar.nextYear': 'Next year',
        'tecton.element.calendar.today': ' Today',
        'tecton.element.calendar.days.Sunday': 'Sunday',
        'tecton.element.calendar.days.Monday': 'Monday',
        'tecton.element.calendar.days.Tuesday': 'Tuesday',
        'tecton.element.calendar.days.Wednesday': 'Wednesday',
        'tecton.element.calendar.days.Thursday': 'Thursday',
        'tecton.element.calendar.days.Friday': 'Friday',
        'tecton.element.calendar.days.Saturday': 'Saturday',
        'tecton.element.calendar.days.short.Sunday': 'S',
        'tecton.element.calendar.days.short.Monday': 'M',
        'tecton.element.calendar.days.short.Tuesday': 'T',
        'tecton.element.calendar.days.short.Wednesday': 'W',
        'tecton.element.calendar.days.short.Thursday': 'T',
        'tecton.element.calendar.days.short.Friday': 'F',
        'tecton.element.calendar.days.short.Saturday': 'S',
        'tecton.element.calendar.months.January': 'January',
        'tecton.element.calendar.months.February': 'February',
        'tecton.element.calendar.months.March': 'March',
        'tecton.element.calendar.months.April': 'April',
        'tecton.element.calendar.months.May': 'May',
        'tecton.element.calendar.months.June': 'June',
        'tecton.element.calendar.months.July': 'July',
        'tecton.element.calendar.months.August': 'August',
        'tecton.element.calendar.months.September': 'September',
        'tecton.element.calendar.months.October': 'October',
        'tecton.element.calendar.months.November': 'November',
        'tecton.element.calendar.months.December': 'December',
        'tecton.element.input.clear': 'Clear {0}',
        'tecton.element.input.optional': '(optional)',
        'tecton.element.section.collapse': 'Collapse',
        'tecton.element.section.expand': 'Expand',
        'tecton.element.editableField.save': 'Save Edit',
        'tecton.element.editableField.cancel': 'Cancel Edit',
        'tecton.element.editableField.edit': 'Edit',
        'tecton.element.loading.ariaLabel': 'Loading',
        'tecton.element.select.multiDisplay': '{0} selected',
        'tecton.element.select.multiHeader.showing': 'Showing:',
        'tecton.element.select.multiHeader.all': 'All',
        'tecton.element.select.multiHeader.selected': 'Selected ({0})',
        'tecton.element.dropdownItem.remove': 'Remove Option {0}'
    },
    'es-MX': {
        'tecton.element.calendar.close': 'Cerrar',
        'tecton.element.calendar.previousMonth': 'Mes anterior',
        'tecton.element.calendar.nextMonth': 'Próximo mes',
        'tecton.element.calendar.previousYear': 'Año anterior',
        'tecton.element.calendar.nextYear': 'Próximo año',
        'tecton.element.calendar.today': 'Hoy',
        'tecton.element.calendar.days.Sunday': 'Domingo',
        'tecton.element.calendar.days.Monday': 'Lunes',
        'tecton.element.calendar.days.Tuesday': 'Martes',
        'tecton.element.calendar.days.Wednesday': 'Miércoles',
        'tecton.element.calendar.days.Thursday': 'Jueves',
        'tecton.element.calendar.days.Friday': 'Viernes',
        'tecton.element.calendar.days.Saturday': 'Sábado',
        'tecton.element.calendar.days.short.Sunday': 'D',
        'tecton.element.calendar.days.short.Monday': 'L',
        'tecton.element.calendar.days.short.Tuesday': 'Ma',
        'tecton.element.calendar.days.short.Wednesday': 'Mi',
        'tecton.element.calendar.days.short.Thursday': 'J',
        'tecton.element.calendar.days.short.Friday': 'V',
        'tecton.element.calendar.days.short.Saturday': 'D',
        'tecton.element.calendar.months.January': 'Enero',
        'tecton.element.calendar.months.February': 'Febrero',
        'tecton.element.calendar.months.March': 'Marzo',
        'tecton.element.calendar.months.April': 'Abril',
        'tecton.element.calendar.months.May': 'Mayo',
        'tecton.element.calendar.months.June': 'Junio',
        'tecton.element.calendar.months.July': 'Julio',
        'tecton.element.calendar.months.August': 'Agosto',
        'tecton.element.calendar.months.September': 'Septiembre',
        'tecton.element.calendar.months.October': 'Octubre',
        'tecton.element.calendar.months.November': 'Noviembre',
        'tecton.element.calendar.months.December': 'Diciembre',
        'tecton.element.input.clear': 'Eliminar {0}',
        'tecton.element.input.optional': '(opcional)',
        'tecton.element.section.collapse': 'Contraer',
        'tecton.element.section.expand': 'Expandir',
        'tecton.element.editableField.save': 'Guardar cambio',
        'tecton.element.editableField.cancel': 'Cancelar edición',
        'tecton.element.editableField.edit': 'Editar',
        'tecton.element.loading.ariaLabel': 'Cargando',
        'tecton.element.select.multiDisplay': '{0} seleccionado',
        'tecton.element.select.multiHeader.showing': 'Mostrando',
        'tecton.element.select.multiHeader.all': 'Todos',
        'tecton.element.select.multiHeader.selected': 'Seleccionado ({0})',
        'tecton.element.dropdownItem.remove': 'Eliminar la opción {0}'
    }
};
